import Axios from "axios";

var aiBaseURL = (process.env.VUE_APP_API_URL || "https://api.arboran.com.br/api/")
  .replace(/\/api\/$/, "/ai-service/api/v1");
if (process.env.NODE_ENV === "development") {
  aiBaseURL = "http://localhost:8000/api/v1";
}

const aiHttp = Axios.create({
  baseURL: aiBaseURL
});

const local = JSON.parse(localStorage.getItem("user-token"));
if (local) {
  aiHttp.defaults.headers.common["Authorization"] = "bearer " + local.token;
}

aiHttp.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error && error.response && error.response.status === 401) {
      localStorage.removeItem("user-token");
      window.location.reload();
    }
    return Promise.reject(error);
  }
);

class InstitutionalTeamService {
  Get(contaId) {
    return aiHttp({
      url: "/institutional-team/" + contaId,
      method: "GET"
    });
  }

  Save(contaId, payload) {
    return aiHttp({
      url: "/institutional-team/" + contaId,
      data: payload,
      method: "PUT"
    });
  }

  ExportDocx(contaId) {
    return aiHttp({
      url: "/institutional-team/" + contaId + "/export",
      method: "GET",
      responseType: "blob"
    });
  }
}

export default new InstitutionalTeamService();
